import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { PACK_HASH } from '@app-types/home-pack';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class SmartTvJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.SMART_TV;
    protected readonly showComparatorSelection = false;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_SMART_TV;
    protected readonly wordings = {
        mainTitle: 'On regarde les offres Smart TV disponibles chez vous\u00A0?',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly tracking = {
        page: 'Eligibilite_test_smart_tv',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_Smart_TV',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: 'La fibre est nécessaire pour profiter de la série spéciale Bbox Smart TV',
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Popin_adresse_non_eligible_smart_tv',
            nomClic: 'Ok',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_smart_tv',
            nomClic: 'Eligibilite_ko_smart_tv',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly technologies = [TECHNOLOGY.FTTH];
    protected readonly showComboProductSlug = [PACK_HASH.SMART_TV, PACK_HASH.VIDEOPROJECTOR, PACK_HASH.SMART_MONITOR];
    protected readonly extraCmsBlockByTab = {};
}
